export const SecurityApiRoutes = {
  generateCaptcha: `/usuario/captcha-generator`,
  login: `/usuario/login-web`,
  logout: `/usuario/logout`,
  sendCodeVerification: `/Usuario/SendCodeVerification`,
  getUserInfo: `/contacto/getContactoVerifyByMail`,
  signUp: `/Usuario/activarUsuario`,
  unlockUser: `/Usuario/DesbloqueoUsuario`,
  changePasswordUser: `/Usuario/ActualizaPassUsuario`,
  validateUserByEmail: `/Usuario/validaUserByMail`,
} as const;

export const HelpDeskApiRoutes = {
  myTickets: `/Ticket/getListTicketsByUser`,
  detailTicket: `/Ticket/getListTicketsById`,
  myPendingTickets: `/Ticket/getListPendingTickets`,
  closeTicket: `/Ticket/CloseTicket`,
  closeAllTickets: `/Ticket/CloseAllTickets`,
  attendTickets: `/Ticket/GetListTareasbyUsuario`,
  getReasonsCancellation: `/Ticket/getMotivosAnulacion`,
  rejectTicketAp: `/Ticket/RechazarTareaTicket`,
  reassignTicket: `/Ticket/ReasignacionTarea`,
  getReassignmentPartners: `/Ticket/getColaborador`,
  cancelTicket: `/Ticket/AnulaTareaTicketByUser`,
  rejectTicketAt: `/Ticket/AnulaTareaTicket`,
  approveTicket: `/Ticket/AprobarTareaTicket`,
  solveTicket: `/Ticket/TareaCompleted`,
  getSupportItems: `/Ticket/getTemasAyuda`,
  getModuleSystems: `/Ticket/getSistemaMod`,
  getRequirements: `/Ticket/getIncidencias`,
  createTicket: `/Ticket/registrarTicket`,
  pendingTicketsClosed: `/Ticket/getVerifyTicketsPend`,
  getContacts: `/Contacto/getContactos`,
  quickSearchRequeriments: `/Ticket/getListIncidencias`,
} as const;

export const SupplierVisitsRoutes = {
  getSuppliers: `/supplierVisits/get-suppliers`,
  getDepartments: `/supplierVisits/get-departments`,
  getPerson: `/supplierVisits/get-person`,
  registerPerson: `/supplierVisits/register-person`,
  registerScheduledVisit: `/supplierVisits/register-scheduled-visit`,
  getScheduledVisits: `/supplierVisits/get-scheduled-visits`,
} as const;

export const ManufacturingRoutes = {
  getTypesRequest: `/v1/Masters/typesRequest`,
  getTypesMaterial: `/v1/Masters/typesMaterial`,
  getProductLines: `/v1/Masters/productLines`,
  getProductHierarchys: `/v1/Masters/productHierarchys`,
  getCoatingtTypes: `/v1/Masters/coatingtTypes`,
  getCoatingtTypesWithoutPlastified: `/v1/Masters/coatingtTypesWithoutPlastified`,
  getCoatingSubtypes: `/v1/Masters/coatingSubtypes`,
  getClosureTypes: `/v1/Masters/closureTypes`,
  getSalesOrganizations: `/v1/Masters/salesOrganizations`,
  getSalesChannels: `/v1/Masters/salesChannels`,
  getLogisticsCenter: `/v1/Masters/logisticsCenter`,
  getStatesMachine: `/v1/Masters/statesMachine`,
  getBwgConfig: `/v1/Masters/bwgConfig`,
  getRecords: `/v1/Request/getRecords`,
  getRequests: `/v1/Request/getRequest`,
  createRequest: `/v1/Request/insertRecord`,
  createRequestByProductLine: `/v1/Request/InsertRequest`,
  uploadDetailAttachment: `/v1/Request/uploadDetailAttachment`,
  getMaterial: `/v1/Material/getMaterial`,
  getRecordDetail: `/v1/Request/getRecordDetail`,
  createMaterial: `/v1/Material/insert`,
  getMeasureUnit: `/v1/Masters/measureUnit`,
  getRouteSheetGroup: `/v1/Masters/routeSheetGroup`,
  getResources: `/v1/Masters/resources`,
  getResourcesByRouteProcessName: `/v1/Masters/resourcesByRouteProcessName`,
  getResourcesBy: `/v1/Masters/resourcesBy`,
  updateRequestState: `/v1/Request/UpdateRequestState`,
  getResourceById: `/v1/Masters/resourceById`,
  getMaterialByCode: `/v1/Material/getMaterialByCode`,
  calcSheetSku: `/v1/SheetSku/calc`,
  calcSheetSkuV2: `/v1/SheetSku/calcV2`,
  createRoute: `/v1/Material/insertRoute`,
  getConsolidatedMaterial: `/v1/Material/getConsolidatedMaterial`,
  getColors: `/v1/Masters/colors`,
  getMeasureUnitByProductLine: `/v1/Masters/GetMeasureUnitByProductLine`,
  getDestination: `/v1/Masters/GetDestination`,
  getSurfaceFinish: `/v1/Masters/GetSurfaceFinish`,
  getRodTypes: `/v1/Masters/GetRodTypes`,
  getSubRodTypes: `/v1/Masters/GetSubRodTypes`,
  getSurfaceByProductLine: `/v1/Masters/GetSurfaceByProductLine`,
  getConsolidatedRecipe: `/v1/Material/getConsolidatedRecipe`,
  getConsolidatedVersion: `/v1/Material/getConsolidatedVersion`,
  checkStatusMaterialInitializers: `/v1/Material/checkStatusMaterialInitializers`,
  getMaterialRouteLog: `/v1/Material/GetMaterialRouteLog`,
  insertRouteWithAlternative: `/v1/Material/insertRouteWithAlternative`,
  getSurface: `/v1/Masters/GetSurface`,
  getCoatingTypeByProductLine: `/v1/Masters/GetCoatingTypeByProductLine`,
  getPackaging: `/v1/Masters/GetPackaging`,
  getWireTypeByProductLine: `/v1/Masters/GetWireTypeByProductLine`,
  getCarbonTypeByProductLine: `/v1/Masters/GetCarbonTypeByProductLine`,
  getPresentationByProductLine: `/v1/Masters/GetPresentationByProductLine`,
  getWireHardness: `/v1/Masters/GetWireHardness`,
  getTypeMaterialList: `/v1/TypeMaterial`,
  getTypeMaterialById: `/v1/TypeMaterial`,
  insertTypeMaterial: `/v1/TypeMaterial`,
  updateTypeMaterial: `/v1/TypeMaterial`,
  disableTypeMaterial: `/v1/TypeMaterial/disable`,
  enableTypeMaterial: `/v1/TypeMaterial/enable`,
  // Carga de materiales
  getTemplateLoadMaterialUrl: `/v1/LoadMaterial/get-template-url`,
  processLoadMaterials: `/v1/LoadMaterial/process-load-materials`,
  validateLoadMaterials: `/v1/LoadMaterial/validate-load-materials`,
  // resources
  getResourcesList: `/v1/Resources`,
  getResourcesDetailById: `/v1/Resources`,
  insertResource: `/v1/Resources`,
  updateResource: `/v1/Resources`,
  // spped trefilado
  getResourceSpeedTrefiladoList: `/v1/ResourceSpeedTrefilado`,
  getResourceSpeedTrefiladoById: `/v1/ResourceSpeedTrefilado`,
  insertResourceSpeedTrefilado: `/v1/ResourceSpeedTrefilado`,
  updateResourceSpeedTrefilado: `/v1/ResourceSpeedTrefilado`,
  //download trama
  getTramaDownload: `/v1/Bot/downloadTrama`,
  // spped varilla
  getResourceSpeedVarillaList: `/v1/ResourceSpeedVarilla`,
  getResourceSpeedVarillaById: `/v1/ResourceSpeedVarilla`,
  insertResourceSpeedVarilla: `/v1/ResourceSpeedVarilla`,
  updateResourceSpeedVarilla: `/v1/ResourceSpeedVarilla`,
  // spped plastificado
  getResourceSpeedPlastificadoList: `/v1/ResourceSpeedPlastificado`,
  getResourceSpeedPlastificadoById: `/v1/ResourceSpeedPlastificado`,
  insertResourceSpeedPlastificado: `/v1/ResourceSpeedPlastificado`,
  updateResourceSpeedPlastificado: `/v1/ResourceSpeedPlastificado`,
  // speed alambre galvanizado
  getResourceSpeedAlambreGalvanizadoList: `/v1/ResourceSpeedAlambreGalvanizado`,
  getResourceSpeedAlambreGalvanizadoById: `/v1/ResourceSpeedAlambreGalvanizado`,
  insertResourceSpeedAlambreGalvanizado: `/v1/ResourceSpeedAlambreGalvanizado`,
  updateResourceSpeedAlambreGalvanizado: `/v1/ResourceSpeedAlambreGalvanizado`,
  // mantenedor de ficha olimpica
  getSheetOlimpicaList: `/v1/SheetSkuOlimpica`,
  getSheetOlimpicaById: `/v1/SheetSkuOlimpica`,
  // mantenedor de ficha olimpica plastificada
  getSheetPlastificadoList: `/v1/SheetSkuPlastificado`,
  getSheetPlastificadoById: `/v1/SheetSkuPlastificado`,
  // dashboard request
  getRequestsDashboardMetrics: `v1/RequestDashboard/metrics`,
} as const;
